import axios, { isCancel } from '../axios';

export const getMe = async () => {
  try {
    const res = await axios.get('users/me');
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const updateMe = async data => {
  try {
    const res = await axios.patch(`users/me`, data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const getUsersList = async (params, signal) => {
  try {
    const res = await axios.get('users/', { params, signal });
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const getUserById = async (id, signal) => {
  try {
    const res = await axios.get(`users/${id}`, { signal });
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const updateUsers = async (id, data) => {
  try {
    const res = await axios.patch(`users/${id}`, data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};
